import React, { useState } from "react";
import UIComponent from "components/UiComponent";
import EvaluationItem from "./ListItem";
import ListItemModal from './ListItemModal';
import config from "root/../config";
import evaluationConfig from "../../../moduleConfig";
import AppContext from "components/appContext";
import authService from "services/authService";
import dataService from "services/dataService";
import MsgBox from "sis_ui/modules/notifications";
import { useTranslation } from "react-i18next";
import { withRouter } from "components/Routing";
import "../../../evaluations.less";


export const learnerNotClickableList = ["PENDING","IN_PROGRESS","UNDER_REVISION","COURSE_DIRECTOR_REVIEW"];

export const checkIfEvaluationIsClickable = ({evaluation,currentRole,learnerNotClickableList, checkRequiredEvaluation=false}) => {

  if(checkRequiredEvaluation && evaluation.HAS_REQUIRED_EVAL == 'Y') return true;

  //check if evaluation is workflow based

  if(evaluation.WORKFLOW_ACTIONS.includes('WORKFLOW_ACTION_AVAILABLE')) return true;

  // case when evaluation is non-workflow based

  if(evaluation.WORKFLOW_ID != '-1' && evaluation.WORKFLOW_ACTIONS == '') {

    if(currentRole == 'SUPERVISOR' || (currentRole == 'TRAINEE' && !learnerNotClickableList.includes(evaluation.STATUS_CODE) )) {

      return true;

    }        

  }  else if(evaluation.WORKFLOW_ACTIONS != '') {

    return true;

  }

  return false;         

}

const EvaluationList = ({ filter, router }) => {
  const { navigate, location } = router;  
  const initialState = {
    open: false,
    isLoading: false,
    type: "",    
    requiredEvaluations: [],
  };
  const [state, setState] = useState(initialState);

  const closeModal = () => {
    setState({
      ...state,
      open: false,
      isLoading: false,
    });
  };

  const { t } = useTranslation();
  const ignoreCacheLocalStorage =
    window.localStorage.getItem("evaluations-list-igonre-cache") == "true";
  const ignoreCahe =
    !(
      location &&
      location.pathname.indexOf(evaluationConfig.map.EVALUATION_FORM.path) >= 0
    ) || ignoreCacheLocalStorage;

  return (
    <AppContext.Consumer>
      {(data) => {
        const currentRole = data.userDetails.CURRENT_ROLE;
        return (
          <React.Fragment>
          <ListItemModal open={state.open} isLoading={state.isLoading} data={state.requiredEvaluations} type={state.type} closeModal={closeModal}/>           
            {filter ? (
              <UIComponent
                component="highlight-wrapper"
                keyword={filter ? filter.search.search_string : null}
              >
                <UIComponent
                  id="evaluations-list"
                  component="data-view"
                  mode="LIST"
                  url={config.apiAppUrl + evaluationConfig.APIs.getEvaluations}
                  urlParams={{
                    auth_token: authService.getToken(),
                    user_role: currentRole,
                    filter: JSON.stringify(filter),
                  }}
                  itemComponent={EvaluationItem}
                  listCardHeight={150}
                  listCardMargin={"7px 15px"}
                  fetchMethod="POST"
                  pullToRefresh
                  onScroll={(scrollValues) => {
                    data.updateScrollValue(scrollValues.scrollTop);
                  }}
                  refreshOnUrlParamsChange={authService.getToken() ? true : false}
                  requestIndexModifier={1}
                  ignoreCache={ignoreCahe}
                  getPublicData={(publicData) => {
                    window.addEventListener(
                      "orientationchange",
                      function () {
                        if (
                          publicData.hasOwnProperty("recalculateRowHeights")
                        ) {
                          setTimeout(() => {
                            publicData.recalculateRowHeights();
                          }, 50);
                        }
                      },
                      false
                    );
                  }}
                  onItemClick={(event, data) => {
                    if (data.HAS_REQUIRED_EVAL == 'Y') {
                      setState((prevState) => ({
                        ...prevState,
                        open: true,
                        isLoading: true,
                        type:'REQUIRED_EVALUATIONS'
                      }));

                      const requiredEvalReq = dataService
                        .postRequest({
                          key: "eventData",
                          value: JSON.stringify({
                            EVALUATION_ID: data.EVALUATION_ID,
                            USER_ROLE: currentRole,
                          }),
                          url:
                            config.apiAppUrl +
                            evaluationConfig.APIs.getRequiredEvaluations,
                        })
                        .accept("application/json");

                      requiredEvalReq
                        .then((res) => {
                          try {
                            let result = res.body;
                            // result should be an array of required evaluations
                            if (result.length > 0) {
                              setState((prevState) => ({
                                ...prevState,
                                requiredEvaluations: result,
                                isLoading: false,
                              }));
                            } else {
                              setState((prevState) => ({
                                ...prevState,
                                open: false,
                                isLoading: false,
                              }));
                            }
                          } catch (e) {
                            MsgBox.drawMessage(
                              "error",
                              t(
                                "lbl.INVALID_RESPONSE",
                                "Invalid response format"
                              )
                            );
                          }
                        })
                        .catch((e) => {
                          MsgBox.drawMessage(
                            "error",
                            t(
                              "lbl.ERROR_PROCESSING_REQUEST",
                              "There was an error processing your request"
                            )
                          );
                        });
                    } else if (!checkIfEvaluationIsClickable({evaluation:data,currentRole,learnerNotClickableList}))  {
                        setState({
                          ...state,
                          open: true,
                          type:"NOT_ACCESSIBLE"                                        
                        });
                    } else {
                      navigate(
                        "/" +
                          evaluationConfig.map.EVALUATION_FORM.path +
                          "/" +
                          data.USER_FORM_ID,
                        {
                          state: {
                            WORKFLOW_ID: !!data.WORKFLOW_ID
                              ? data.WORKFLOW_ID
                              : "",
                          },
                        }
                      );
                    }
                  }}
                  onLoad={() => {
                    window.localStorage.removeItem(
                      "evaluations-list-igonre-cache"
                    );
                  }}
                />
              </UIComponent>
            ) : null}
          </React.Fragment>
        );
      }}
    </AppContext.Consumer>
  );
};

export default withRouter(EvaluationList);
